import { deviceStatsSelector } from "fleet/redux-store/ui-state/device-stats/selectors";
import { connect } from "react-redux";
import { storesReady } from "redux-store";
import { applicationsSelector } from "redux-store/applications/selectors";

import { DeviceDetails } from "./device-details";

function mapStateToProps(state) {
  const applications = applicationsSelector(state);
  const statsState = deviceStatsSelector(state);
  const storesLoaded = storesReady(state.global.applications);

  return {
    applications,
    statsState,
    storesLoaded,
  };
}

const ConnectedDeviceDetails = connect(mapStateToProps)(DeviceDetails);

export { ConnectedDeviceDetails };
